import TestingBase from './TestingBase';
import {apisconfig} from '../config/apisconfig';

export {TestingBase};


export const findTesting = (service:string) => {
  const apis:any = apisconfig;
  return apis[service];
}

export const getTesting = (service:string) => {
  const apis:any = apisconfig;
  return apis[service];
}
